import request from './axios'

// 执行流程
export function SaveStep (data) {
  return request.post('/api', data, { timeout: 10 * 60000 })
}

// 查询智能体工作流Key
export function GetLableItems (data) {
  return request.get('/api/AI/GetLableItems', data)
}
